import { c as _c } from "react/compiler-runtime";
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { useEffect, useRef, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { UnsavedEmailsEnum } from 'shared/components/dashboard-mail-editor/enums/unsaved-emails-enum';
import database from 'shared/db';
import { EmailsInterface } from 'shared/db/tables/emails';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface UseUnsavedEmailInterface {
  mailingId?: MailingId;
  initialBody?: string;
  currentBody?: string;
  type?: UnsavedEmailsEnum;
  onPaste: (data: string) => void;
  showImmediately?: boolean;
}
export const useUnsavedEmail = t0 => {
  const $ = _c(37);
  const {
    mailingId,
    initialBody,
    currentBody,
    type,
    onPaste,
    showImmediately
  } = t0;
  const [opened, setOpened] = useState(false);
  const [needToShowModal, setNeedToShowModal] = useState(!!showImmediately);
  const timerRef = useRef(null);
  const {
    t
  } = useLocoTranslation();
  const initial = initialBody;
  const current = currentBody;
  const [tempBody, setTempBody] = useState();
  let t1;
  let t2;
  if ($[0] !== initial) {
    t1 = () => {
      if (initial !== undefined) {
        setTempBody(initial);
      }
    };
    t2 = [initial];
    $[0] = initial;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== current || $[4] !== mailingId || $[5] !== needToShowModal || $[6] !== type) {
    t3 = () => {
      if (!needToShowModal || !mailingId && !type) {
        return;
      }
      const checkDbRecord = async () => {
        const existingRecord = mailingId ? await database.emails.where("mailing_id").equals(mailingId).first() : type ? await database.emails.where("type").equals(type).first() : undefined;
        if (existingRecord && existingRecord.body !== current) {
          setTempBody(existingRecord.body);
          setOpened(true);
        }
        setNeedToShowModal(false);
      };
      checkDbRecord();
    };
    t4 = [current, mailingId, needToShowModal, type];
    $[3] = current;
    $[4] = mailingId;
    $[5] = needToShowModal;
    $[6] = type;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== current || $[10] !== initial || $[11] !== mailingId || $[12] !== opened || $[13] !== tempBody || $[14] !== type) {
    t5 = () => {
      if (initial === undefined || !current || tempBody === undefined) {
        return;
      }
      if (opened || current === tempBody || !mailingId && !type) {
        return;
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(async () => {
        const existingRecord_0 = mailingId ? await database.emails.where("mailing_id").equals(mailingId).first() : type ? await database.emails.where("type").equals(type).first() : undefined;
        const addRecord = async () => {
          if (existingRecord_0) {
            existingRecord_0.body = current;
            await database.emails.put(existingRecord_0);
          } else {
            const newRecord = {
              mailing_id: mailingId || null,
              type: type || null,
              body: current
            };
            await database.emails.add(newRecord);
          }
          setTempBody(current);
        };
        try {
          await addRecord();
        } catch {
          const firstRecord = database.emails.offset(0);
          if (firstRecord) {
            await firstRecord.delete();
            await addRecord();
          }
        }
      }, 3000);
      return () => clearTimeout(timerRef.current || 0);
    };
    t6 = [current, initial, mailingId, opened, tempBody, type];
    $[9] = current;
    $[10] = initial;
    $[11] = mailingId;
    $[12] = opened;
    $[13] = tempBody;
    $[14] = type;
    $[15] = t5;
    $[16] = t6;
  } else {
    t5 = $[15];
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] !== onPaste || $[18] !== tempBody) {
    t7 = () => {
      if (!tempBody) {
        return;
      }
      onPaste(tempBody);
    };
    $[17] = onPaste;
    $[18] = tempBody;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const pasteUnsavedData = t7;
  let t8;
  if ($[20] !== current || $[21] !== mailingId || $[22] !== type) {
    t8 = async () => {
      if (mailingId) {
        const existingRecord_1 = database.emails.where("mailing_id").equals(mailingId);
        if (existingRecord_1) {
          await existingRecord_1.delete();
          setTempBody(current);
        }
      } else {
        if (type) {
          const existingRecord_2 = database.emails.where("type").equals(type);
          if (existingRecord_2) {
            await existingRecord_2.delete();
            setTempBody(current);
          }
        }
      }
    };
    $[20] = current;
    $[21] = mailingId;
    $[22] = type;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const removeDbRecord = t8;
  let t9;
  if ($[24] !== t) {
    t9 = t("dashboard.email.confirm_unsaved_email");
    $[24] = t;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== removeDbRecord) {
    t10 = async () => {
      await removeDbRecord();
    };
    $[26] = removeDbRecord;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setOpened(false);
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== opened || $[30] !== pasteUnsavedData || $[31] !== t10 || $[32] !== t9) {
    t12 = <ConfirmationModal confirmationText={t9} opened={opened} onDecline={t10} onClose={t11} onConfirm={pasteUnsavedData} />;
    $[29] = opened;
    $[30] = pasteUnsavedData;
    $[31] = t10;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const UnsavedEmailConfirmationModal = t12;
  let t13;
  if ($[34] !== UnsavedEmailConfirmationModal || $[35] !== removeDbRecord) {
    t13 = {
      UnsavedEmailConfirmationModal,
      removeDbRecord,
      setNeedToShowModal
    };
    $[34] = UnsavedEmailConfirmationModal;
    $[35] = removeDbRecord;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};